export default __webpack_public_path__ + "static/media/Smart Heart Rabbit Food Veggies & Cereals.107cba63.png";